import Footer from "../../components/common/layout/Footer";
import { TermandConditionContent, Breadcrumbs } from "@/components/features/termandcondition";
import SEO from "@/components/common/seo/seo";

export default function terms() {
  return (
    <div>
      <SEO
          title="Terms and Conditions - SAN micron"
          description="Review our comprehensive Terms and Conditions to understand your rights and responsibilities when using our services."
      />
      <Breadcrumbs />
      <TermandConditionContent />
      <Footer />
    </div>
  )
}